import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5AB50A00-46F7-4294-8462-EDD32EA7309A
 * name printer-3d-nozzle-alert
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-3d-nozzle-alert.svg
 * tags
 * - Alert / Error 
 * - Printer 
 */
export const Printer3dNozzleAlertIcon = createSvgIcon(<><path d="M7 2H17V8H19V13H16.5L13 17H11L7.5 13H5V8H7V2M10 22H2V20H10C10.6 20 11 19.5 11 19V18H13V19C13 20.7 11.7 22 10 22M21 13V7H23V13H21M21 17V15H23V17H21Z" /></>, 'Printer3dNozzleAlertIcon');
export default Printer3dNozzleAlertIcon